@if (subjectId !== 'Math') {
  <span>
    <span class="data-label font-size-14px" [ngClass]="fontSize"
      >Directions:
    </span>
    <span
      class="data-value font-size-14px"
      [ngClass]="fontSize"
      [innerHTML]="directions"
    ></span>
  </span>
}
@if (subjectId === 'Math') {
  <span>
    <span class="data-label font-size-14px">What This Connects To: </span>
    @if (objectives) {
      <span
        class="data-value font-size-14px"
        [ngClass]="fontSize"
        [innerHTML]="objectives"
      ></span>
    }
    @if (!objectives) {
      <span
        class="data-value font-size-14px"
        [ngClass]="fontSize"
        >N/A</span
        >
      }
    </span>
  }
